export default (opts = {}) => {
    const component = {
        model: {
            defaults: {
              tagname: 'div',
              name: "Colunas Numeros",
              attributes: { class: 'row-cubo' },
              components: [
                {
                  type: 'columnNumbers6',
                },
                {
                  type: 'columnBigNumbers6',
                },
      
              ],
              styles: `
             .row-cubo{
                display: flex; 
                flex-direction:row; 
                width:100%; 
             }
             @media (max-width:992px){
              .row-cubo{
                flex-direction:column;
              }
             }
            `,
            },
          },
          view: {
      
          },
};
  return component; 
};